import { useFormContext } from 'react-hook-form'
import { WorkforceFormData } from '../schemas/workforceSchema'

export function useWorkforceFormContext() {
    return useFormContext<WorkforceFormData>()
}
